import MetaCampaignTableFilter from './meta-campaign-table-filters';

export default MetaCampaignTableFilter;